export enum COMMS_DELIVERY_PREFERENCES {
  EMAIL = 'EMAIL',
  POSTAL_MAIL = 'POSTAL_MAIL',
}
